<template>
  <el-switch @change="change" v-model="hasLcrModule"></el-switch>
</template>

<script>
export default {
  data() {
    return {
      hasLcrModule: false
    }
  },
  beforeMount() {
    let dat = this.params.data;
    // debugger
    // this.hasLcrModule = (this.params.data.has_lcr === 1)
    let post = this.params.data.account_manager_user_id
    let pree = this.params.props.passed.id
    let is = post == pree ? true : false ;
    this.hasLcrModule = is;
    // this.hasLcrModule = this.params.data.account_manager_user_id == this.params.props.passed.id

  },
  
  methods: {
    change(val) {
         
          let account_manager_id = this.params.props.passed.id;
          debugger
      // console.log(par);
      
      let data = {
        value: val,
        userId: this.params.data.user_id,
        accountManagerId : account_manager_id
      }
      // debugger
      this.params.props.actionsHandler('assignResellersToAccountManager', data)
    }
  }
}
</script>
